// Query helpers for the People and Companies lists and the role-change
// dismissal (docs/crm/api.md, "API polish"). Filtering, sorting and paging
// all happen on the server; saved views stay client-side for now.
import { del, get, post } from "./api";

export const DUE_VIEWS = ["overdue", "due_soon", "snoozed"];

export const CONTACT_SORTS = [
    { value: "name", label: "Name" },
    { value: "next_due", label: "Next due" },
    { value: "last_touch", label: "Last touch" },
    { value: "tier", label: "Tier" },
];

export const COMPANY_SORTS = [
    { value: "name", label: "Name" },
    { value: "next_due", label: "Next due" },
    { value: "last_touch", label: "Last touch" },
    { value: "score", label: "Score" },
];

// The due views read best most-overdue first; the rest by name.
export const defaultSort = (view) => (DUE_VIEWS.includes(view) ? "next_due" : "name");

// GET /v1/crm/contacts params for a built-in view ("all", a due view or
// "role_changed") plus the filter bar.
export function contactListParams({ view = "all", q, tier, tag, sort, page = 1, pageSize = 50 }) {
    return {
        q: q || undefined,
        tier: tier || undefined,
        tag: tag || undefined,
        due_status: DUE_VIEWS.includes(view) ? view : undefined,
        role_changed: view === "role_changed" ? "true" : undefined,
        sort: sort || defaultSort(view),
        page,
        page_size: pageSize,
    };
}

// GET /v1/crm/companies params for a built-in view ("all", "kept" or a due
// view) plus the filter bar.
export function companyListParams({ view = "all", q, status, tag, sort, page = 1, pageSize = 50 }) {
    return {
        q: q || undefined,
        status: status || undefined,
        tag: tag || undefined,
        keep_in_touch: view === "kept" ? "true" : undefined,
        due_status: DUE_VIEWS.includes(view) ? view : undefined,
        sort: sort || defaultSort(view),
        page,
        page_size: pageSize,
    };
}

// Counts for the due view tabs, from the list endpoint itself so a tab's
// count matches its rows (hidden records, E12, are left out of both; the
// due list /v1/crm/due keeps them).
export async function dueViewCounts(endpoint) {
    const [overdue, dueSoon, snoozed] = await Promise.all(
        ["overdue", "due_soon", "snoozed"].map((s) => get(endpoint, { due_status: s, page_size: 1 }).then((r) => r.count))
    );
    return { overdue, due_soon: dueSoon, snoozed };
}

// "Role changed" dismissals are stored on the contact (audited); undo
// clears them.
export const dismissRoleChange = (id) => post(`v1/crm/contacts/${id}/role-change/dismiss`);
export const undismissRoleChange = (id) => del(`v1/crm/contacts/${id}/role-change/dismiss`);
